import { useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Link, useOutletContext } from "react-router-dom";

const PRESETS = {
  403: {
    kicker: "Error 403",
    title: "Access denied",
    message: "You don't have permission to view this page.",
  },
  404: {
    kicker: "Error 404",
    title: "Page not found",
    message: "The page you're looking for doesn't exist or has moved.",
  },
};

export default function ErrorPage({ code = 404 }) {
  const { page } = useOutletContext() ?? {};
  const preset = PRESETS[code] ?? PRESETS[404];

  useEffect(() => {
    const base = page?.title ? page.title.split("—")[0].trim() : "PMP";
    document.title = `${preset.title} · ${base}`;
    return () => {
      if (page?.title) document.title = page.title;
    };
  }, [preset.title, page?.title]);

  return (
    <section className="py-5 pmp-section-alt flex-grow-1">
      <Container className="py-4">
        <p className="pmp-kicker mb-2">{preset.kicker}</p>
        <h1 className="h3 mb-3">{preset.title}</h1>
        <p className="text-secondary mb-4">{preset.message}</p>
        <Link to="/" className="btn btn-primary">
          Back to home
        </Link>
      </Container>
    </section>
  );
}
